export default __webpack_public_path__ + "static/media/fad-stereo.2386fc6d.svg";